import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

ReactDOM.render(
  <App
    spreadsheetId="1kjQZXy-m_ioxhJxHWC5PdeqeIBLsavHWVbq38Fz9ou4"
    clientId="459216665265-rg4ujqcjinpgo3dlgqaori593ufgr8vr.apps.googleusercontent.com"
    apiKey="AIzaSyDsY_aP9gOZD7WWUbpjDnB3aeBSC-zXlhA"
  />,
  document.querySelector("#app")
);
